import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSellerOnboarding } from './useSellerOnboarding';
import OnboardingHeader from './OnboardingHeader';
import OnboardingContent from './OnboardingContent';
import LoadingState from './LoadingState';
import { styles } from './styles';

const SellerOnboardingPage = () => {
  const {
    user,
    authLoading,
    loading,
    handleSellerOnboardingComplete,
    shouldRedirectToLogin,
    shouldRedirectToDashboard
  } = useSellerOnboarding();

  if (authLoading || loading) {
    return (
      <div style={styles.container}>
        <LoadingState />
      </div>
    );
  }

  if (shouldRedirectToLogin) {
    return <Navigate to="/login" />;
  }

  if (shouldRedirectToDashboard) {
    return <Navigate to="/seller-dashboard" />;
  }

  return (
    <div style={styles.container}>
      <OnboardingHeader />
      <OnboardingContent 
        user={user}
        onComplete={handleSellerOnboardingComplete}
      />
    </div>
  );
};

export default SellerOnboardingPage;